import * as React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { InputAdornment } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import pitcLogo from '../../../images/pitcLogo.png';
import usLogo from '../../../images/usLogo.png';
import { useNavigate, Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { forgotpasswordSchema } from "../../../schemas/forgot";
import './forgotpassword.scss';
import { cfpBaseUrl } from '../../../network/urls';
import AppLoader from '../../../components/AppLoader/AppLoader';
import eOpsLogo from '../../../images/eops.png'


const initialValues = {
  Username: "",
  PhoneLast4: "",
};
const Forgotpassword = () => {
  const [isLoadingSpinner, setIsLoadingSpinner] = React.useState(false);
  const [formError, setFormError] = React.useState('');

  const Navigate = useNavigate();
  const { values, errors, touched, handleBlur, handleSubmit, setFieldValue } =
    useFormik({
      initialValues,
      validationSchema: forgotpasswordSchema,
      onSubmit: async (values) => {
        setIsLoadingSpinner(true);
        setFormError('');
        const USERNAME = values.Username;
        const myHeaders = new Headers();
        myHeaders.append('Authorization', '');
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify({
          userId: values.Username.trim(),
          phoneNo: values.PhoneLast4.trim(),
        });

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        // Exact endpoint: {cfpBaseUrl}customerFaciliationPortal/forgotPassword
        try {
          const response = await fetch(
            `${cfpBaseUrl}customerFaciliationPortal/forgotPassword`,
            requestOptions
          );
          const resultText = await response.text();
          let result = {};
          try {
            result = resultText ? JSON.parse(resultText) : {};
          } catch (e) {
            setIsLoadingSpinner(false);
            setFormError(resultText || 'Unexpected response from server.');
            return;
          }

          if (result.status === '200' || result.status === 200) {
            const otpval = result.otp;
            setIsLoadingSpinner(false);
            if (otpval) {
              Navigate('/otp-verification', { state: { otpval, USERNAME } });
            } else {
              Navigate('/');
            }
          } else {
            setIsLoadingSpinner(false);
            setFormError(result.message || 'Unable to verify user.');
          }
        } catch (e) {
          setIsLoadingSpinner(false);
          setFormError('Something went wrong. Please try again.');
        }
      },
    });
  return (
    <>
      <Grid className='background'>

        <form className='forgotpasswordform'>
          <img src={eOpsLogo} alt="eOps" className='logo' />
          <Box className='form-fields'>
            <TextField
              type='text'
              margin="normal"
              className='textfield'
              required
              fullWidth
              value={values.Username}
              name="Username"
              onChange={(e) => setFieldValue('Username', e.target.value)}
              onBlur={handleBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <EmailIcon className='icon' />
                  </InputAdornment>
                )
              }}
              id="Username"
              label=""
              placeholder='Username'
              autoComplete=""
              size='small'
            />
            {errors.Username && touched.Username ? (
              <p className="form-error">{errors.Username}</p>
            ) : null}
            <TextField
              type='text'
              margin="normal"
              className='textfield'
              required
              fullWidth
              value={values.PhoneLast4}
              name="PhoneLast4"
              onChange={(e) => {
                const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 4);
                setFieldValue('PhoneLast4', digitsOnly);
              }}
              onBlur={handleBlur}
              inputProps={{ maxLength: 4, inputMode: 'numeric' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <PhoneAndroidIcon className='icon' />
                  </InputAdornment>
                )
              }}
              id="PhoneLast4"
              label=""
              placeholder='Phone last 4 digits'
              autoComplete=""
              size='small'
            />
            {errors.PhoneLast4 && touched.PhoneLast4 ? (
              <p className="form-error">{errors.PhoneLast4}</p>
            ) : null}
            {formError ? <p className="form-error">{formError}</p> : null}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className='form-button'
              onClick={handleSubmit}
              disabled={isLoadingSpinner}
              sx={{ textTransform: 'capitalize' }}
            >
              {isLoadingSpinner ? (
                <Box sx={{ display: 'flex' }}>
                  <AppLoader size="1.7rem" />
                </Box>
              ) : (
                'Verify User'
              )}
            </Button>
           
            < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
            <Grid className='powered-by'>
              <Box className='form-bottom-link'>
                <Link to='/'  >
                  Sign in
                </Link>
              </Box>
              <Grid className='logos'>
                <img className='usaid' src={usLogo} alt="" />
                <img className='pitc' src={pitcLogo} alt="" />
              </Grid>
            </Grid>
          </Box>
        </form>
      </Grid>
    </>
  );
}
export default Forgotpassword;
